export const getSelectedFareGroup = (state) => state.selectedFareGroup;
